export type OwnerId = string;
export interface HasOwner {
    ownerId: OwnerId;
}
export interface HasPrivacy {
    privacy?: "public" | "member" | "instructor" | "restricted";
}

/** Bump this string whenever the privacy policy / TOS changes materially.
 *  Existing users whose stored consent.policyVersion doesn't match will be
 *  re-prompted to confirm their privacy choice. */
export const CURRENT_PRIVACY_POLICY_VERSION = "2026-05-22";

export interface PrivacyConsent {
    policyVersion: string;
    /** The default privacy posture the user picked at consent time. */
    privacyChoice: "public" | "member";
    /** Whether they checked the "I agree to the privacy policy & terms" box. */
    agreedToTerms: boolean;
    /** Epoch ms timestamp at consent recording. */
    consentedAt: number;
}

export interface HasConsent {
    consent?: PrivacyConsent;
}
